module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Ge-Ha 后背.4dfc9dcf.png";